import { call, put, takeLatest } from "redux-saga/effects";
import { GET_AuditList, GET_AuditFilters } from "../services/Audit";
import exception from "../utils/exception";
import { jwtDecode } from "../utils/jwt";
import { getToken } from "../utils/token";

function* GET_AuditListEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_AuditList, token, payload);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_AuditList", payload: resData.data });
    if (callback) callback(resData.data);
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* GET_AuditFiltersEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_AuditFilters, token, payload);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_AuditFilters", payload: resData.data });
    if (callback) callback(resData.data);
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

export default function* AuditSaga() {
  yield takeLatest("GET_AuditList", GET_AuditListEffect);
  yield takeLatest("GET_AuditFilters", GET_AuditFiltersEffect);
}
